import type { UseListOptions } from "./list.type";
import type { ApiError, ApiPayloadList } from "@/services/api";

import { useQuery } from "@tanstack/react-query";
import get from "lodash/get";

import { client } from "@/config/client";
import { QUERY_PERSIST_KEY } from "@/services/query";

export const useList = <Data = unknown>(
  endpoint: string,
  {
    params = {},
    rootId = null,
    neverStale = false,
    persist = false,
    queryKeyExtraParams = [],
    enabled = true,
    ...otherOptions
  }: UseListOptions<Data> = {}
) => {
  const persistKey = persist ? [QUERY_PERSIST_KEY] : [];
  const queryKey = [
    endpoint,
    "list",
    rootId,
    params,
    ...queryKeyExtraParams,
    ...persistKey,
  ].filter(Boolean);

  return useQuery<ApiPayloadList<Data>, ApiError>({
    queryKey,
    queryFn: async () => {
      const response = rootId
        ? await get(client, endpoint).list(rootId, params)
        : await get(client, endpoint).list(params);

      return response.data;
    },
    staleTime: neverStale ? Infinity : 0,
    enabled,
    ...otherOptions,
  });
};
